import { type UserDetail, createUserDetail } from 'models';
import { useQuery } from 'query';
import { getUser } from '../services';
import type { UserFilter } from '../types';
import { getUserQueryKey } from './keys';

type P = {
  filter: UserFilter;
  options?: { throwOnError?: boolean };
};

export const useUserQuery = ({ filter, options }: P) =>
  useQuery<UserDetail>({
    enabled: Boolean(filter.userId),
    gcTime: 0,
    async queryFn() {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- TODO: fix this
      const response = await getUser({ routeParams: { id: filter.userId! } });

      return createUserDetail(response.data);
    },
    queryKey: getUserQueryKey({ filter }),
    staleTime: 0,
    throwOnError: true,
    ...options,
  });
